import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectForm from "@/pages/ProjectForm";
import ProjectDetail from "@/pages/ProjectDetail";
import Customers from "@/pages/Customers";
import Vehicles from "@/pages/Vehicles";
import PreOrders from "@/pages/PreOrders";
import RepairOrders from "@/pages/RepairOrders";
import RepairOrderDetail from "@/pages/RepairOrderDetail";
import SpkPrint from "@/pages/SpkPrint";
import Spareparts from "@/pages/Spareparts";
import DailyReports from "@/pages/DailyReports";
import Estimates from "@/pages/Estimates";
import EstimateForm from "@/pages/EstimateForm";
import EstimateDetail from "@/pages/EstimateDetail";
import Rab from "@/pages/Rab";
import RabDetail from "@/pages/RabDetail";
import Hpp from "@/pages/Hpp";
import HppDetail from "@/pages/HppDetail";
import Users from "@/pages/Users";
import Audit from "@/pages/Audit";
import Settings from "@/pages/Settings";
import Employees from "@/pages/Employees";
import PettyCash from "@/pages/PettyCash";
import JurnalUmum from "@/pages/JurnalUmum";
import MaterialUsage from "@/pages/MaterialUsage";
import RoleRoute, { AccessDenied } from "@/components/RoleRoute";
import { R } from "@/lib/routeRoles";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route element={<RoleRoute roles={R.projects} />}>
                <Route path="/projects" element={<Projects />} />
                <Route path="/projects/:id" element={<ProjectDetail />} />
                <Route path="/projects/:id/spk" element={<SpkPrint />} />
              </Route>
              <Route element={<RoleRoute roles={R.projectCreate} />}><Route path="/projects/new" element={<ProjectForm />} /></Route>
              <Route element={<RoleRoute roles={R.projectEdit} />}><Route path="/projects/:id/edit" element={<ProjectForm />} /></Route>
              <Route element={<RoleRoute roles={R.master} />}>
                <Route path="/customers" element={<Customers />} />
                <Route path="/vehicles" element={<Vehicles />} />
              </Route>
              <Route element={<RoleRoute roles={R.employees} />}><Route path="/employees" element={<Employees />} /></Route>
              <Route element={<RoleRoute roles={R.finance} />}>
                <Route path="/petty-cash" element={<PettyCash />} />
                <Route path="/jurnal-umum" element={<JurnalUmum />} />
              </Route>
              <Route element={<RoleRoute roles={R.materialUsage} />}><Route path="/material-usage" element={<MaterialUsage />} /></Route>
              <Route element={<RoleRoute roles={R.spareparts} />}><Route path="/spareparts" element={<Spareparts />} /></Route>
              <Route element={<RoleRoute roles={R.production} />}>
                <Route path="/pre-orders" element={<PreOrders />} />
                <Route path="/repair-orders" element={<RepairOrders />} />
                <Route path="/repair-orders/:id" element={<RepairOrderDetail />} />
              </Route>
              <Route element={<RoleRoute roles={R.dailyReports} />}><Route path="/daily-reports" element={<DailyReports />} /></Route>
              <Route element={<RoleRoute roles={R.estimates} />}>
                <Route path="/estimates" element={<Estimates />} />
                <Route path="/estimates/:id" element={<EstimateDetail />} />
              </Route>
              <Route element={<RoleRoute roles={R.estimateManage} />}>
                <Route path="/estimates/new" element={<EstimateForm />} />
                <Route path="/estimates/:id/edit" element={<EstimateForm />} />
              </Route>
              <Route element={<RoleRoute roles={R.rab} />}>
                <Route path="/rab" element={<Rab />} />
                <Route path="/rab/:id" element={<RabDetail />} />
              </Route>
              <Route element={<RoleRoute roles={R.hpp} />}>
                <Route path="/hpp" element={<Hpp />} />
                <Route path="/hpp/:projectUuid/:vehicleId" element={<HppDetail />} />
              </Route>
              <Route element={<RoleRoute roles={R.users} />}><Route path="/users" element={<Users />} /></Route>
              <Route element={<RoleRoute roles={R.audit} />}><Route path="/audit" element={<Audit />} /></Route>
              <Route path="/settings" element={<Settings />} />
              <Route path="*" element={<AccessDenied />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
